import { createVNode as o, mergeProps as e } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/TransactionFilledStandard.js";
import d from "../components/PfIcon.js";
const r = (t, a) => {
  const n = {
    ...t,
    ...a.attrs
  };
  return o(d, e(n, {
    icon: i
  }), null);
};
r.displayName = "TransactionFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
